import React from 'react';
import './SubmitPopup.css'; // Import your CSS file for styling

function SubmitPopup({ onClose }) {
  return (
    <div className="popup">
      <div className="popup-content">
        <h2>Your plantation details are successfully submitted!</h2>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

export default SubmitPopup;
